<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <GoTop></GoTop>
    <!-- <Dify></Dify> -->
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.underline-animation {
  display: inline;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
}

.underline-animation::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: blue;
  transition: width 2s;
}

.underline-animation:hover::after {
  width: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue